import ScrollSpy from "bootstrap/js/src/scrollspy";
import {initScrollspy} from '../inits/_scrollspy.init.js'
import {initColPadding} from "../inits/_news-detail.col-padding.init.js";
import {initSwiper} from "../inits/_swipers.init.js";
import {
  initBackgroundGridAnimation,
  initCardImageAnimation,
  initFooterC2aAnimation,
  refreshAllScrollTriggers
} from "../inits/_animatons.init.js";

(() => {
  initSwiper();
  initScrollspy(ScrollSpy);
  initColPadding();
  initCardImageAnimation();
})();

(() => {
  initBackgroundGridAnimation()
  initFooterC2aAnimation();
  refreshAllScrollTriggers();
})();

window.addEventListener('resize', () => {
  refreshAllScrollTriggers();
}, {passive: true});
